@for (item of inputItems; track item) {
  <ui-form-select
    [data]="item"
    (valueChanges)="onSelectionChange($index, $event)"
  ></ui-form-select>
}
